import { Route, Routes } from 'react-router';

import { commonRoutes } from '../../shared/helpers/routing';
import { useAuthToken } from '../../shared/hooks/useAuthToken';
import { NoContext } from './no-context';

export function NoContextRoutes() {
  const { isInvencoUser } = useAuthToken();
  return (
    <Routes>
      <Route index element={<NoContext />} />
      {commonRoutes(isInvencoUser)}
    </Routes>
  );
}
